import { useEffect } from "react";

const addSlot = "68c3c05e77f8f70f850bafc6";

export function AdsBitmedia() {
  useEffect(() => {
    const hosts = ["cdn.bmcdn6.com"];
    const file = addSlot;

    function loadScript(m = 0) {
      const s = document.getElementsByClassName(addSlot)[0] || null;

      const script = document.createElement("script");
      script.async = true;
      script.src = `https://${
        hosts[m]
      }/js/${file}.js?v=${new Date().getTime()}`;

      script.onerror = () => {
        script.remove();
        if (m + 1 < hosts.length) loadScript(m + 1);
      };

      if (s && s.parentNode) {
        s.parentNode.append(script);
      } else {
        const target =
          document.head || document.body || document.documentElement;
        target.appendChild(script);
      }
      return () => {
        script.remove();
      };
    }

    const sr = loadScript();
    return () => {
      sr();
    };
  }, []);

  return (
    <div className="w-full h-[100px] overflow-hidden adsSlider flex items-center justify-center">
      <ins
        className={addSlot}
        id={addSlot}
        style={{
          display: "inline-block",
          width: "100%",
          height: 100,
        }}
      ></ins>
    </div>
  );
}
